import {Injectable} from '@angular/core';

import {City} from '../models/city';

import {HttpClient} from '@angular/common/http';
import {BaseService} from '../../../services/base.service';
import {Observable} from 'rxjs';
import {Store} from "../models/store";
import {AuthService} from "./auth.service";


@Injectable({
    providedIn: 'root'
})
export class StoresService extends BaseService {

    httpOptions;

    constructor(private authService: AuthService, private httpClient: HttpClient) {
        super();

        this.httpOptions = authService.getHttpOptions();
    }

    // get atm Store
    public getStores(): Observable<any> {

        return this.httpClient.get(`${this.apiURL}/stores`, {headers: this.authService.getHttpOptions()});

    }



    // get store by id
    public getStore(id) {

        return this.httpClient.get<Store>(`${this.apiURL}/stores/` + id, {headers: this.authService.getHttpOptions()});

    }


    // add Store
    public addStore(branch: Store) {

        return this.httpClient.post<any>(`${this.apiURL}/stores`, branch, {headers: this.authService.getHttpOptions()});

    }

    // update Store
    public updateStore(branch: Store) {

        return this.httpClient.put<any>(`${this.apiURL}/stores`, branch, {headers: this.authService.getHttpOptions()});

    }

    // delete atm
    public removeStore(id) {

        return this.httpClient.delete<any>(`${this.apiURL}/stores/` + id, {headers: this.authService.getHttpOptions()});

    }


}
